// extracted by mini-css-extract-plugin
export default {"payment-method-display":"payment-method-display-2ebd","icon":"icon-f757","fee":"fee-1287","not-verified-payment":"not-verified-payment-a63f"};